import { ButtonBase, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

import { appColors } from '../assets/appColors';

type TextWithEmbeddedButtonProps = Readonly<{
  text: string;
  buttonText: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}>;

export const TextWithEmbeddedButton = ({
  text,
  buttonText,
  onClick,
  sx,
}: TextWithEmbeddedButtonProps) => {
  const indexOfButton = text.indexOf(buttonText);
  const firstPart = text.slice(0, indexOfButton);
  const secondPart = text.slice(indexOfButton + buttonText.length);

  return (
    <Typography sx={sx}>
      {firstPart}
      <ButtonBase sx={embeddedButtonStyle} onClick={onClick} disableRipple>
        {buttonText}
      </ButtonBase>
      {secondPart}
    </Typography>
  );
};

const embeddedButtonStyle: SxProps<Theme> = {
  color: appColors.color.navy2,
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 700,
  verticalAlign: 'baseline',
};
